import {
  addHours,
  eachDayOfInterval,
  format,
  parse,
  startOfMonth,
} from "date-fns";
import { enUS } from "date-fns/locale";

export const getDayAndMonth = (date: Date | null | undefined) => {
  if (date) {
    return format(date, "d MMMM", { locale: enUS });
  }
  return "unknown";
};

export const getRangeOfDays = (startDate: Date, endDate: Date) => {
  if (!startDate || !endDate) {
    return [];
  }

  // If identical dates (including time), return array with single date
  if (startDate.getTime() === endDate.getTime()) {
    return [startDate];
  }

  // If the start is after end, return empty array (avoid throwing)
  if (startDate.getTime() > endDate.getTime()) {
    return [];
  }

  try {
    return eachDayOfInterval({ start: startDate, end: endDate });
  } catch (e) {
    // Defensive fallback if date-fns throws for any interval issue
    return [];
  }
};

export const getStartMonth = (date: Date) => {
  return startOfMonth(date);
};

export const defaultDateSelectDayStart = addHours(new Date(), -24);

export const defaultDateSelectDayEnd = new Date();

export const convertMinutesToHours = (minutes: number) => {
  const h = Math.floor(minutes / 60);
  const m = minutes % 60;
  return `${h}h ${m}m`;
};

export const convertUTCtoCET = (utcTimestamp: number) => {
  // Create a Date object with the UTC timestamp
  const utcDate = new Date(utcTimestamp);

  // Get the UTC hours and add the CET offset (1 hour)
  const cetHours = utcDate.getUTCHours() + 1;

  // Set the hours to CET hours
  utcDate.setUTCHours(cetHours);

  // Return the new timestamp in number format
  return utcDate.getTime();
};

export const formatDate = (dateString: string | undefined) => {
  // Parse the input date string as dd-MM-yyyy
  if (!dateString) {
    return "";
  }
  const parsedDate = parse(dateString, "MM/dd/yyyy", new Date());

  // Format the parsed date to "EEEE d-M-yyyy"
  const formattedDate = format(parsedDate, "EEEE d-M-yyyy");

  return formattedDate;
};

export const formatDateGitHub = (dateString: string | undefined) => {
  if (!dateString) {
    return "";
  }
  const parsedDate = parse(dateString.split("T")[0], "yyyy-MM-dd", new Date());
  const formattedDate = format(parsedDate, "d-M-yyyy");

  return formattedDate;
};
